'use client';

import { usePathname } from "next/navigation";

import React, { useEffect, useState } from "react";
import Head from "../../components/ContactUs/Head";
import ContactForm from "../../components/ContactUs/ContactForm";
import SectionType1 from "../../components/Sections/SectionType1";
import ContactDetailsMap from "../../components/ContactUs/ContactDetailsMap";

import {

  FaCode,
  FaMobile,
  FaToolbox,
  FaPaintbrush,
  FaChartLine,
  FaServer,
  FaRobot,
  FaBagShopping,
  FaPlay,
  FaCloud,
  FaGamepad,
  FaRProject,
  FaUsers,
  FaDatabase,
  FaUpload,
  FaPencil,
  FaCartFlatbed,
  FaCriticalRole,
  FaEye,
  FaRocket,
  FaCalendar,
  FaFlagCheckered,
} from "react-icons/fa6";
import { AiOutlineMobile } from "react-icons/ai";
import { MdDesignServices, MdSecurity } from "react-icons/md";

const s1 = "/assets/services/5.webp";
const s2 = "/assets/services/6.png";
const s3 = "/assets/services/10.jpg";
const s4 = "/assets/services/1.jpg";
const s5 = "/assets/services/4.jpg";
const s6 = "/assets/services/3.jpg";
const s7 = "/assets/services/2.webp";
const s8 = "/assets/services/7.jpg";
const s9 = "/assets/services/11.jpg";
const s10 = "/assets/services/9.jpg";
const s11 = "/assets/services/12.webp";
const s12 = "/assets/services/8.jpg";

// const services = [
//   {
//     id: 1,
//     image: s1,
//     title: "Website Design & Development",
//     description: "Websites for performance and user engagement.",
//     tags: [
//       { text: "Custom Websites", icon: FaCode },
//       { text: "Optimized", icon: FaBagShopping },
//       { text: "Scalable", icon: FaMobile },
//       { text: "SEO", icon: FaChartLine },
//     ],
//   },
//   {
//     id: 2,
//     image: s2,
//     title: "Mobile App Development",
//     description: "Optimized Apps for iOS and Android.",
//     tags: [
//       { text: "Native Apps", icon: AiOutlineMobile },
//       { text: "Cross-Platform", icon: FaMobile },
//       { text: "Push Alerts", icon: FaChartLine },
//       { text: "App Store", icon: FaToolbox },
//     ],

//   },
//   {
//     id: 3,
//     image: s3,
//     title: "Custom Software Development",
//     description: "Scalable software tailored to business needs.",
//     tags: [
//       { text: "Automation", icon: FaRProject },
//       { text: "Custom Features", icon: FaToolbox },
//       { text: "Data Security", icon: MdSecurity },
//       { text: "AI Integration", icon: FaRobot },
//     ],
//   },
//   {
//     id: 4,
//     image: s4,
//     title: "UI/UX Design",
//     description: "Exceptional designs for usability and aesthetics.",
//     tags: [
//       { text: "User Research", icon: FaUsers },
//       { text: "Prototyping", icon: FaPaintbrush },
//       { text: "Interactive", icon: FaCode },
//       { text: "Responsive", icon: FaMobile },
//     ],
//   },
//   {
//     id: 5,
//     image: s5,
//     title: "Consulting Services",
//     description: "Expert advice for IT and business optimization.",
//     tags: [
//       { text: "Risk Analysis", icon: FaToolbox },
//       { text: "Cloud Setup", icon: FaCloud },
//       { text: "Automation", icon: FaRobot },
//       { text: "Strategy", icon: FaChartLine },
//     ],
//   },
//   {
//     id: 6,
//     image: s6,
//     title: "Live Streaming Platform",
//     description: "High-quality solutions for real-time video streaming.",
//     tags: [
//       { text: "HD Streaming", icon: FaPlay },
//       { text: "Live Chat", icon: FaServer },
//       { text: "Scheduling", icon: FaCalendar },
//       { text: "Analytics", icon: FaChartLine },
//     ],
//   },
//   {
//     id: 7,
//     image: s7,
//     title: "E-commerce Development",
//     description: "Secure, scalable platforms for seamless shopping.",
//     tags: [
//       { text: "Storefronts", icon: FaBagShopping },
//       { text: "Easy Payments", icon: MdSecurity },
//       { text: "Inventory", icon: FaDatabase },
//       { text: "Mobile Ready", icon: FaMobile },
//     ],
//   },
//   {
//     id: 8,
//     image: s8,
//     title: "Cloud Services",
//     description: "Reliable solutions for secure data access and storage.",
//     tags: [
//       { text: "Quick Hosting", icon: FaCloud },
//       { text: "Monitoring", icon: FaChartLine },
//       { text: "Migration", icon: FaUpload },
//       { text: "Security", icon: MdSecurity },
//     ],
//   },
//   {
//     id: 9,
//     image: s9,
//     title: "Product Development",
//     description: "Complete solutions from design to market launch.",
//     tags: [
//       { text: "Scalable Design", icon: FaPencil },
//       { text: "Testing", icon: FaFlagCheckered },
//       { text: "Agile Method", icon: FaCriticalRole },
//       { text: "Launch", icon: FaRocket },
//     ],
//   },
//   {
//     id: 10,
//     image: s10,
//     title: "AI & Machine Learning",
//     description: "Intelligent solutions for automation and insights.",
//     tags: [
//       { text: "Personalized", icon: FaChartLine },
//       { text: "Automation", icon: FaRobot },
//       { text: "AI Models", icon: FaCode },
//       { text: "Big Data", icon: FaServer },
//     ],
//   },
//   {
//     id: 11,
//     image: s11,
//     title: "Graphic Design & Marketing",
//     description: "Creative designs to boost brand visibility.",
//     tags: [
//       { text: "Branding", icon: FaPaintbrush },
//       { text: "Social Media", icon: FaChartLine },
//       { text: "Quality Content", icon: FaToolbox },
//       { text: "Advertising", icon: FaBagShopping },
//     ],
//   },
//   {
//     id: 12,
//     image: s12,
//     title: "Game Development",
//     description: "Cutting-edge games with immersive experiences.",
//     tags: [
//       { text: "3D Models", icon: FaGamepad },
//       { text: "Multiplayer", icon: FaServer },
//       { text: "Cross-Platform", icon: AiOutlineMobile },
//       { text: "VR/AR", icon: FaCode },
//     ],
//   },
// ];
const services = [
  {
    id: 1,
    image: s1,
    title: "Website Design & Development",
    description: "Websites for performance and user engagement.",
    tags: [
      { text: "Custom Websites", icon: FaCode },
      { text: "Optimized", icon: FaBagShopping },
      { text: "Scalable", icon: FaMobile },
      { text: "SEO", icon: FaChartLine },
    ],
  },
  {
    id: 2,
    image: s2,
    title: "Mobile App Development",
    description: "Optimized Apps for iOS and Android.",
    tags: [
      { text: "Native Apps", icon: AiOutlineMobile },
      { text: "Cross-Platform", icon: FaMobile },
      { text: "Push Alerts", icon: FaChartLine },
      { text: "App Store", icon: FaToolbox },
    ],
  },
  {
    id: 3,
    image: s3,
    title: "Custom Software Development",
    description: "Scalable software tailored to business needs.",
    tags: [
      { text: "Automation", icon: FaRProject },
      { text: "Custom Features", icon: FaToolbox },
      { text: "Data Security", icon: MdSecurity },
      { text: "AI Integration", icon: FaRobot },
    ],
  },
  {
    id: 4,
    image: s4,
    title: "UI/UX Design",
    description: "Exceptional designs for usability and aesthetics.",
    tags: [
      { text: "User Research", icon: FaUsers },
      { text: "Prototyping", icon: FaPaintbrush },
      { text: "Interactive", icon: FaCode },
      { text: "Responsive", icon: FaMobile },
    ],
  },
  {
    id: 5,
    image: s5,
    title: "Consulting Services",
    description: "Expert advice for IT and business optimization.",
    tags: [
      { text: "Risk Analysis", icon: FaToolbox },
      { text: "Cloud Setup", icon: FaCloud },
      { text: "Automation", icon: FaRobot },
      { text: "Strategy", icon: FaChartLine },
    ],
  },
  {
    id: 6,
    image: s6,
    title: "Live Streaming Platform",
    description: "High-quality solutions for real-time video streaming.",
    tags: [
      { text: "HD Streaming", icon: FaPlay },
      { text: "Live Chat", icon: FaServer },
      { text: "Scheduling", icon: FaCalendar },
      { text: "Analytics", icon: FaChartLine },
    ],
  },
  {
    id: 7,
    image: s7,
    title: "E-commerce Development",
    description: "Secure, scalable platforms for seamless shopping.",
    tags: [
      { text: "Storefronts", icon: FaBagShopping },
      { text: "Easy Payments", icon: MdSecurity },
      { text: "Inventory", icon: FaDatabase },
      { text: "Mobile Ready", icon: FaMobile },
    ],
  },
  {
    id: 8,
    image: s8,
    title: "Cloud Services",
    description: "Reliable solutions for secure data access and storage.",
    tags: [
      { text: "Quick Hosting", icon: FaCloud },
      { text: "Monitoring", icon: FaChartLine },
      { text: "Migration", icon: FaUpload },
      { text: "Security", icon: MdSecurity },
    ],
  },
  {
    id: 9,
    image: s9,
    title: "Product Development",
    description: "Complete solutions from design to market launch.",
    tags: [
      { text: "Scalable Design", icon: FaPencil },
      { text: "Testing", icon: FaFlagCheckered },
      { text: "Agile Method", icon: FaCriticalRole },
      { text: "Launch", icon: FaRocket },
    ],
  },
  {
    id: 10,
    image: s10,
    title: "AI & Machine Learning",
    description: "Intelligent solutions for automation and insights.",
    tags: [
      { text: "Personalized", icon: FaChartLine },
      { text: "Automation", icon: FaRobot },
      { text: "AI Models", icon: FaCode },
      { text: "Big Data", icon: FaServer },
    ],
  },
  {
    id: 11,
    image: s11,
    title: "Graphic Design & Marketing",
    description: "Creative designs to boost brand visibility.",
    tags: [
      { text: "Branding", icon: FaPaintbrush },
      { text: "Social Media", icon: FaChartLine },
      { text: "Quality Content", icon: FaToolbox },
      { text: "Advertising", icon: FaBagShopping },
    ],
  },
  {
    id: 12,
    image: s12,
    title: "Game Development",
    description: "Cutting-edge games with immersive experiences.",
    tags: [
      { text: "3D Models", icon: FaGamepad },
      { text: "Multiplayer", icon: FaServer },
      { text: "Cross-Platform", icon: AiOutlineMobile },
      { text: "VR/AR", icon: FaCode },
    ],
  },
];

function ContactUs() {
  const location = usePathname();
  const initialService = location.state?.service || "3";
  const [matchid, setMatchid] = useState(initialService);
  const matchedService = services.find((service) => service.id == matchid);
  // if (!matchedService) {
  //   return (
  //     <div className="bg-green-900 text-green-100 p-6 rounded-2xl shadow-lg">
  //       <h2 className="text-2xl font-bold mb-4">Service Not Found</h2>
  //       <p>Please check the service ID.</p>
  //     </div>
  //   );
  // }
  return (
    <>
        <div className="absolute w-full -left-1/2 pointer-events-none z-30">
          <div className="mt-20 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        </div>
        <div className="absolute w-full -right-1/2 pointer-events-none z-30">
          <div className="mt-20 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        </div>

        <SectionType1>
          <Head />
        </SectionType1>

        <SectionType1>
          <div className="flex flex-col-reverse lg:flex-row justify-center items-center lg:items-start  gap-8 p-5">
            {/* <div>{matchid}</div> */}
            <div className=" text-color-1 text-center  max-w-md">
              <h1 className="text-3xl font-bold mb-2 md:mt-0 mt-12 ">
                {matchedService?.title}
              </h1>
              <p className=" mb-10 text-color-2" >
                {matchedService?.description}
              </p>

              {/* To restore rates, import ServicePricing and render it with serviceId={matchid}. */}
              <p className="text-color-2">
                Every project starts with your goals. Tell us what you want to
                achieve, and our team will prepare a proposal tailored to your
                scope and requirements.
              </p>
            </div>
            <ContactForm matchid={matchid} setMatchid={setMatchid} />
          </div>
        </SectionType1>
        <ContactDetailsMap />

        {/* <SectionType1>
          <ContactForm />
        </SectionType1> */}
    </>
  );
}

export default ContactUs;
